import axios from 'axios'
import Service from '@/api/service'
import getFormDataFromJSON from '@/common/js/formdata'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
  update: payload => {
    return axios.put('/admin/core/settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/settings/', payload)
  }
}

export const Attachment = {
  ...Service('/admin/attachments/:id/'),
  upload: payload => {
    return axios.post('/admin/attachments/', payload, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  }
}

export const Article = {
  ...Service('/admin/articles/:id/'),
  setOrder(payload) {
    return axios.post('/admin/articles/set-order/', payload)
  }
}

export const ArticleTag = {
  ...Service('/admin/articles/tags/:id/')
}

export const CustomForm = {
  ...Service('/forms/admin/:id/'),
  all() {
    return axios.get('/forms/admin/all/')
  },
  fieldTypes() {
    return axios.get('/forms/admin/fields/')
  },
  validateField(payload) {
    return axios.post('/forms/admin/fields/validation', payload)
  },
  fetchFormData: id => {
    return axios.get(`/forms/admin/data/${id}/`)
  },
  exportFormData: id => {
    const config = {
      responseType: 'blob'
    }
    let baseURL = axios.defaults.baseURL
    if (baseURL[baseURL.length - 1] !== '/') {
      baseURL += '/'
    }
    return axios.get(`${baseURL}forms/admin/${id}/export/`, config)
  }
}

export const Page = {
  ...Service('/admin/pages/:id/')
}

export const Event = {
  ...Service('/admin/events/:id/'),
  setOrder(payload) {
    return axios.post('/admin/events/set-order/', payload)
  }
}

export const EventTag = {
  ...Service('/admin/events/tags/:id/')
}

export const EventStatus = {
  fetch: () => {
    return axios.get('/admin/events/statuses/')
  }
}

export const Widget = {
  ...Service('/admin/widgets/:id/'),
  types(params) {
    return axios.get('/widgets/admin/types/', { params })
  },
  validate(payload) {
    return axios.post('/widgets/admin/validate/', payload)
  },
  available(params) {
    return axios.get('/widgets/admin/available/', { params })
  },
  preview(payload) {
    return axios.post('/widgets/admin/preview/', payload)
  }
}

export const Menu = {
  ...Service('/admin/menu/:id/')
}

export const Link = {
  availableLinkOptions() {
    return axios.get('/admin/links/available-options/')
  },
  availableWidgets(params) {
    return axios.get('/admin/links/available-widgets/', { params })
  }
}

export const Logotypes = {
  ...Service('/admin/logotypes/:id/')
}

export const Auth = {
  login(payload) {
    return axios.post('/public/users/auth/login/', payload)
  }
}

export const Image = {
  ...Service('/images/admin/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/images/admin/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/images/admin/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const User = {
  ...Service('/admin/users/:id/')
}

export const Dashboard = {
  getContentCounters() {
    return axios.get('/admin/dashboard/content-counters/')
  },
  getRecentPages() {
    return axios.get('/admin/dashboard/recent-pages/')
  },
  getUser() {
    return axios.get('/admin/dashboard/user/')
  }
}
